import React from 'react';
import Modal from './workspace/Modal';
import VideoEditorPicker from './VideoEditorPicker';
import type {VideoEditor} from '../backend-types/user';

interface VideoEditorGateModalProps {
  isOpen: boolean;
  videoEditor: VideoEditor | null;
  onSelect: (editor: VideoEditor) => void;
  isSaving: boolean;
}

/**
 * The blocking half of the video editor question — see `useVideoEditorPreference` for the logic
 * this wraps, and `account/VideoEditorCard.tsx` for the settings half that lets it be changed later.
 *
 * Mounted once in `AppLayout` so it sits in front of every signed-in page (after the set-password
 * gate, which lives outside `AppLayout` entirely) for as long as `video_editor` is null — a brand
 * new account, or an existing one that cleared its answer from Settings. There is deliberately no
 * `onClear` here and no way to close the dialog: `dismissible={false}` drops the close button and
 * ignores Escape/backdrop clicks, because the whole point is that this is answered, not dismissed.
 * Any pick saves immediately and the gate closes itself once the store reflects it.
 */
const VideoEditorGateModal: React.FC<VideoEditorGateModalProps> = ({
  isOpen,
  videoEditor,
  onSelect,
  isSaving,
}) => (
  <Modal
    isOpen={isOpen}
    dismissible={false}
    title="Which editor do you cut in?"
    subtitle="It tailors the convert dialog's advice on linking your source audio after import.
     You can change your answer any time from Account settings."
    onClose={() => {}}
    widthClass="max-w-md"
  >
    <VideoEditorPicker value={videoEditor} onSelect={onSelect} disabled={isSaving} />
  </Modal>
);

export default VideoEditorGateModal;
